document.addEventListener('DOMContentLoaded', function () {
  /**
   * Scroll animation to the jump to section
   */
  function scrollToHash(hash) {
    const target = document.querySelector(hash);
    const header = document.querySelector('.site-header');
    const offset = header ? header.offsetHeight : 0;

    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = targetPosition - offset;

      setTimeout(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }, 0);
    }
  }

  // Handle clicks on internal links
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const hash = this.getAttribute('href');
      if (hash.length > 1 && document.querySelector(hash)) {
        scrollToHash(hash);
      }
    });
  });

  // Handle initial page load with hash
  if (window.location.hash) {
    scrollToHash(window.location.hash);
  }

  /**
   * Header navigation JavaScript to handle menu improvements.
   */
  if (typeof SV !== 'undefined' && typeof SV?.HoverIntent === 'function') {
    new SV.HoverIntent(document.querySelectorAll('.site-header .top-nav nav > ul > li > details'), {
      onEnter: function (targetItem) {
        targetItem.classList.add('visible');
        targetItem.setAttribute('open', '');
      },
      onExit: function (targetItem) {
        targetItem.classList.remove('visible');
        targetItem.removeAttribute('open');
      },
    });
    
    new SV.HoverIntent(document.querySelectorAll('.site-header .sub-nav nav > ul > li > details'), {
      onEnter: function (targetItem) {
        targetItem.classList.add('visible');
      },
      onExit: function (targetItem) {
        targetItem.classList.remove('visible');
      },
    });
  }

  document.addEventListener('click', function (event) {
    const detailsElements = document.querySelectorAll('.site-header .top-nav details');

    detailsElements.forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
        details.classList.remove('visible');
      }
    });
  });

  // Enhanced keyboard navigation for accessibility
  document.addEventListener('keydown', function(e) {
    // Escape key handling for modals, dropdowns, and drawers
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.modal.active, .drawer.active, [aria-expanded="true"]');
      if (activeModal) {
        activeModal.classList.remove('active');
        activeModal.setAttribute('aria-expanded', 'false');
        const trigger = document.querySelector(`[aria-controls="${activeModal.id}"]`);
        if (trigger) trigger.focus();
      }
    }
    
    // Arrow key navigation for custom components
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      const activeElement = document.activeElement;
      if (activeElement && activeElement.hasAttribute('data-arrow-navigation')) {
        e.preventDefault();
        const nextElement = activeElement.getAttribute('data-arrow-navigation');
        const target = document.querySelector(nextElement);
        if (target) target.focus();
      }
    }
    
    // Enter and Space key handling for custom buttons
    if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute('data-button')) {
      e.preventDefault();
      e.target.click();
    }
  });

  function updateDropdownMaxHeight(menu) {
    if (!menu) return;

    requestAnimationFrame(() => {
      const rect = menu.getBoundingClientRect();
      if (rect.height === 0) return; // Avoid setting height when still hidden

      const viewportHeight = window.innerHeight;
      const availableHeight = viewportHeight - rect.top;

      menu.style.maxHeight = `calc(95vh - ${rect.top}px)`;
    });
  }

  // Watch for `.visible` class changes
  function observeMenuVisibility() {
    document.querySelectorAll('.site-header .header__submenu').forEach((submenu) => {
      const menu = submenu.querySelector('.list-menu');

      if (!menu) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            if (submenu.classList.contains('visible')) {
              updateDropdownMaxHeight(menu);
            }
          }
        });
      });

      observer.observe(submenu, { attributes: true });
    });
  }

  // Run once on page load
  observeMenuVisibility();

  // Recalculate on window resize
  window.addEventListener('resize', () => {
    document.querySelectorAll('.site-header .header__submenu.visible .list-menu').forEach(updateDropdownMaxHeight);
  });

  function quizResultsUI() {
    const introSessionData = localStorage.getItem('introSession');
    if (introSessionData) {
      try {
        const introSession = JSON.parse(introSessionData);
        if (introSession && introSession.shown === true) {
          let placedIntroOrder = localStorage.getItem('placedIntroOrder') === 'true';
          console.log('placedIntroOrder', localStorage.getItem('placedIntroOrder'));
          const headerQuizBtn = document.querySelector('.site-header .quiz-btn');
          
          if (headerQuizBtn) {
            headerQuizBtn.textContent = 'See results';
            headerQuizBtn.setAttribute('href', window.quizSettings.results_url);
          }
          if (window.completedQuizHero) {
            const homeHero = window.completedQuizHero;
            const heroContentElement = homeHero.selector.querySelector('.home-hero-content');
            
            if (heroContentElement) {
              homeHero.selector.classList.add('completed-quiz');
              
              if (placedIntroOrder) {
                // Show order confirmation message with login CTA
                heroContentElement.innerHTML = `
                  <h3>Thank you for your order!</h3>
                  <p>Log in to manage your account</p>
                  <div class="get-started-buttons home-hero-buttons">
                    <a href="/account/login" class="btn primary">Log in</a>
                  </div>
                `;
              } else {
                // Show normal quiz results
                heroContentElement.innerHTML = `
                  ${homeHero.body}
                  <div class="get-started-buttons home-hero-buttons">
                    <a href="${window.quizSettings.results_url}" class="btn primary">${homeHero.results}</a>
                    <a href="${window.quizSettings.url}" class="btn secondary" onClick='localStorage.removeItem("introSession");'>${homeHero.retake}</a>
                  </div>
                `;
              }
            }
          }

          handleIntroCartIcon();
        }
      } catch (error) {}
    }
  }

  function handleIntroCartIcon() {
    try {
      const introSessionData = localStorage.getItem('introSession');
      if (!introSessionData) return;
      
      const introSession = JSON.parse(introSessionData);
      const cartIcon = document.querySelector('#cart-icon-bubble');
      
      if (!introSession || !cartIcon) return;

      // Check if there are intro products but no regular cart items
      const hasIntroProducts = (introSession.products && introSession.products.length > 0) || 
                              (introSession.shown === true && introSession.boxComposition);
      const hasIntroResults = introSession.shown === true;
      const cartIsEmpty = window.Shopify.cart && window.Shopify.cart.item_count === 0;
      const placedIntroOrder = localStorage.getItem('placedIntroOrder') === 'true';

      if (hasIntroProducts && hasIntroResults && cartIsEmpty && !placedIntroOrder) {
        // Calculate intro bottle count using same logic as getIntroStatus
        let bottleCount = 6; // default
        const { boxComposition, order } = introSession;
        
        if (
          boxComposition === '6x2' || 
          boxComposition === '12x1' || 
          order?.item_count === 12
        ) {
          bottleCount = 12;
        } else {
          bottleCount = introSession.products?.length || 6;
        }

        // Update cart icon link to point to results page
        const isLoggedIn = document.querySelector('.account-menu') !== null;
        const resultsUrl = `/a/ui/quiz/${isLoggedIn ? 'checkout' : 'results'}?utm_source=cart_icon`;
        cartIcon.setAttribute('href', resultsUrl);
        
        // Update cart count bubble
        const cartCountBubble = cartIcon.querySelector('.cart-count-bubble');
        if (cartCountBubble) {
          const countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
          if (countSpan) {
            countSpan.textContent = bottleCount;
          }
          const screenReaderSpan = cartCountBubble.querySelector('.visually-hidden');
          if (screenReaderSpan) {
            screenReaderSpan.textContent = `${bottleCount} items in cart`;
          }
        } else {
          // Create cart count bubble if it doesn't exist
          const newBubble = document.createElement('div');
          newBubble.className = 'cart-count-bubble';
          newBubble.innerHTML = `
            <span aria-hidden="true">${bottleCount}</span>
            <span class="visually-hidden">${bottleCount} items in cart</span>
          `;
          cartIcon.appendChild(newBubble);
        }
      } else {
        // Reset cart icon to normal behavior if conditions not met
        cartIcon.setAttribute('href', '/cart');
      }
    } catch (error) {
      console.error('Error handling intro cart icon:', error);
    }
  }

  quizResultsUI();

  // Handle cart updates for intro orders
  function handleCartUpdates() {
    // Listen for cart changes
    document.addEventListener('cart:updated', handleIntroCartIcon);
    document.addEventListener('cart:refresh', handleIntroCartIcon);
    
    // Also handle initial load
    handleIntroCartIcon();
  }

  handleCartUpdates();

  // Watch for cart icon changes with mutation observer
  function watchCartIconChanges() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          // Small delay to ensure DOM is updated
          setTimeout(handleIntroCartIcon, 100);
        }
      });
    });

    observer.observe(cartIcon, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  // Initialize cart icon watcher after a short delay
  setTimeout(watchCartIconChanges, 1000);
});